import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import { Tabs, Card, message } from 'antd'

import storageUtils from '../../utils/storageUtils'
import { req_single_ams_alumni, req_edit_ams_alumni } from '../../api'

const { TabPane } = Tabs

class CounselorEditAlumniModal extends Component {

    // 基礎通用參數 //////////////////////////////////////////////

    static propTypes = {
        alumni: PropTypes.object.isRequired
    }

    state = {
        loading: false,
        item: {}
    }

    constructor(props) {
        super(props)

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleAgree = this.handleAgree.bind(this);
        this.handleDisagree = this.handleDisagree.bind(this);
    }

    UNSAFE_componentWillMount() {

    }

    componentDidMount() {
        this.api_single_item()
    }

    // 遠端數據處理 //////////////////////////////////////////////

    api_single_item = async () => {
        const { token } = this.props.user
        const { TwId } = this.props.alumni
        this.setState({ loading: true })
        const result = await req_single_ams_alumni(TwId, token)
        this.setState({ loading: false })
        const item = result
        this.setState({ item })
    
    }

    api_edit_item = async (item) => {
        const result = await req_edit_ams_alumni(item, storageUtils.getUser().token)
        if (result.status === "success") {
            // console.log(result)
            message.success(result.message)
            this.api_single_item()
        } else {
            message.error(result.message)
        }
    }

    /////////////////////////////////////////////////////////// 

    handleChange(event) {
        const { item } = this.state
        //console.log(event)
        Object.keys(item).forEach(propertyName => {
            if (event.target.id === 'AgreePrivacy' && event.target.value !== null) {
                // Checkbox
                item.AgreePrivacy = event.target.checked
            } else {
                if (event.target.id === propertyName && event.target.value !== null) {
                    item[propertyName] = event.target.value.trim()
                }
            }
        });
        this.setState({ item })
    }

    handleSubmit(event) {
        event.preventDefault()
        const row = this.state.item
        const errors = []

        if (!row.AlumniName.trim()) {
            errors.push('姓名未填')
        }

        if (errors.length === 0) {
            row.TelephoneSurveyOperator = storageUtils.getUser().userCode
            row.NowStatusModifyOperator = storageUtils.getUser().userCode
            row.NowStatusSource = '專員電訪'
            row.NowStatusPrimary = row.NowStatusPrimarySecondary.substr(0, 2)
            row.NowStatusSecondary = row.NowStatusPrimarySecondary.substr(2)
            row.condition = 'PHONEOPERATOR'
            //console.log(row)
            this.api_edit_item(row)
        } else {
            let info = errors.join(',')
            message.error(info);
        }
    }

    handleAgree() {
        const row = this.state.item
        row.AgreePrivacy = true
        this.setState({ item: row })
    }

    handleDisagree() {
        const row = this.state.item
        row.AgreePrivacy = false
        this.setState({ item: row })
    }

    /////////////////////////////
    render() {
        const { TwId, Sex, Birthday, TelephoneSurveyDescription, AlumniName,
            NowStatusPrimary, NowStatusPrimarySecondary, NowStatusDescription,
            MobilePrincipal, MobileSpare, TelephonePrincipal, TelephoneSpare, EmailPrincipal, EmailSpare, MailingAddress, ResidentAddress,
            JobType, JobTitle, JobFirstSalary, CurrentSalary, JobCompany, JobDepartment, JobTelephone, JobFax, JobAddress,
            LastFinalDegree, LastFinalUniversity, LastFinalDepartmentName, LastFinalMajor,
            ContinueLearnUniversity, ContinueLearnDepartmentName, ContinueLearnDegree, ContinueLearnDivision, ContinueLearnLocation } = this.state.item

        return (
            <Card>
                <form onSubmit={this.handleSubmit}>
                    <Tabs defaultActiveKey="1" className="tabsStyle">
                        <TabPane tab={<span><i className="fas fa-user-tag"></i>{' '}基本資料</span>} key="1" >
                            <div className="form-row">
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label>身分證字號</label>
                                        <input type="text" className="form-control text-primary" name="TwId" id="TwId" defaultValue={TwId} disabled={true} />
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label>生日</label>
                                        <input type="text" className="form-control text-primary" name="Birthday" id="Birthday" defaultValue={Birthday} disabled={true} />
                                    </div>
                                </div>
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label>性別</label>
                                        <input type="text" className="form-control text-primary" name="Sex" id="Sex" defaultValue={Sex} disabled={true} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label><span className="text-danger">*</span>姓名</label>
                                        <input type="text" className="form-control text-primary" name="AlumniName" id="AlumniName" aria-describedby="AlumniName" placeholder="請輸入姓名" defaultValue={AlumniName} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-lg-2">
                                    <div className="form-group">
                                        <label>當前狀態</label>
                                        <select name="NowStatusPrimarySecondary" id="NowStatusPrimarySecondary" className="custom-select mb-3 text-success" defaultValue={NowStatusPrimarySecondary} onChange={this.handleChange} key={NowStatusPrimarySecondary} >
                                            <option value="就業自行創業">就業/自行創業</option>
                                            <option value="就業在職進修">就業/在職進修</option>
                                            <option value="升學升學">升學/升學</option>
                                            <option value="就業就業">就業/就業</option>
                                            <option value="服役服役">服役/服役</option>
                                            <option value="留學留學">留學/留學</option>
                                            <option value="其他待業">其他/待業</option>
                                            <option value="其他家管">其他/家管</option>
                                            <option value="其他遊學">其他/遊學</option>
                                            <option value="其他教育實習">其他/教育實習</option>
                                            <option value="其他準備考試">其他/準備考試</option>
                                            <option value="其他尚待確認">其他/尚待確認</option>
                                            <option value="其他拒訪">其他/拒訪</option>
                                            <option value="其他失聯">其他/失聯</option>
                                            <option value="其他歿">其他/歿</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>關於校友補充說明</label>
                                        <input type="text" className="form-control text-primary" id="NowStatusDescription" placeholder="補充說明" defaultValue={NowStatusDescription} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>主要行動電話</label>
                                        <input type="text" className="form-control text-primary" name="MobilePrincipal" id="MobilePrincipal" placeholder="請輸入您常用行動電話" defaultValue={MobilePrincipal} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>備用行動電話</label>
                                        <input type="text" className="form-control text-primary" name="MobileSpare" id="MobileSpare" placeholder="請輸入您備用行動電話" defaultValue={MobileSpare} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>主要電子郵件</label>
                                        <input type="email" className="form-control text-primary" name="EmailPrincipal" id="EmailPrincipal" aria-describedby="emailHelp" placeholder="請輸入您常用電子郵件" defaultValue={EmailPrincipal} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>備用電子郵件</label>
                                        <input type="email" className="form-control text-primary" name="EmailSpare" id="EmailSpare" placeholder="請輸入您備用電子郵件" defaultValue={EmailSpare} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-lg-8">
                                    <div className="form-group">
                                        <label>通訊地址</label>
                                        <input type="text" className="form-control text-primary" name="MailingAddress" id="MailingAddress" placeholder="請輸入您目前通訊地址" defaultValue={MailingAddress} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>通訊地址室內電話</label>
                                        <input type="text" className="form-control text-primary" ame="TelephonePrincipal" id="TelephonePrincipal" nplaceholder="請輸入您通訊地址室內電話" defaultValue={TelephonePrincipal} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-lg-8">
                                    <div className="form-group">
                                        <label>戶籍地址</label>
                                        <input type="text" className="form-control text-primary" name="ResidentAddress" id="ResidentAddress" placeholder="請輸入您戶籍地址" defaultValue={ResidentAddress} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>戶籍地址室內電話</label>
                                        <input type="text" className="form-control text-primary" name="TelephoneSpare" id="TelephoneSpare" placeholder="請輸入您戶籍地址室內電話" defaultValue={TelephoneSpare} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                        {NowStatusPrimary === '就業' ?
                            (<TabPane tab={<span><i className="fas fa-briefcase"></i>{' '}工作現況</span>} key="2" >
                                <div className="form-row">
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <label>工作型態</label>
                                            <input type="text" className="form-control text-primary" name="JobType" id="JobType" placeholder="全職/兼職" defaultValue={JobType} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-lg-5">
                                        <div className="form-group">
                                            <label>工作職稱</label>
                                            <input type="text" className="form-control text-primary" ame="JobTitle" id="JobTitle" nplaceholder="家管/負責人/經理/業務...." defaultValue={JobTitle} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label>第一份薪水金額</label>
                                            <input type="number" className="form-control text-primary" name="JobFirstSalary" id="JobFirstSalary" placeholder="僅填數字" defaultValue={JobFirstSalary} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-lg-2">
                                        <div className="form-group">
                                            <label>當前薪水金額</label>
                                            <input type="number" className="form-control text-primary" name="CurrentSalary" id="CurrentSalary" placeholder="僅填數字" defaultValue={CurrentSalary} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-lg-5">
                                        <div className="form-group">
                                            <label>公司名稱</label>
                                            <input type="text" className="form-control text-primary" name="JobCompany" id="JobCompany" placeholder="公司名稱" defaultValue={JobCompany} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-lg">
                                        <div className="form-group">
                                            <label>隸屬部門</label>
                                            <input type="text" className="form-control text-primary" name="JobDepartment" id="JobDepartment" placeholder="部門名稱" defaultValue={JobDepartment} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                </div>
                                <div className="form-row">
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <label>公司電話</label>
                                            <input type="text" className="form-control text-primary" name="JobTelephone" id="JobTelephone" placeholder="公司電話" defaultValue={JobTelephone} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-lg-3">
                                        <div className="form-group">
                                            <label>傳真電話</label>
                                            <input type="text" className="form-control text-primary" name="JobFax" id="JobFax" placeholder="傳真電話" defaultValue={JobFax} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                    <div className="col-lg">
                                        <div className="form-group">
                                            <label>公司地址</label>
                                            <input type="text" className="form-control text-primary" name="JobAddress" id="JobAddress" placeholder="部門名稱" defaultValue={JobAddress} onChange={this.handleChange} />
                                        </div>
                                    </div>
                                </div>
                            </TabPane>
                            ) : ''}
                        {NowStatusPrimarySecondary === '就業在職進修' ? (<TabPane tab={<span><i className="fas fa-school"></i>{' '}升學進修</span>} key="4" >
                            <div className="form-row">
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label>學校名稱</label>
                                        <input type="text" className="form-control text-primary" name="ContinueLearnUniversity" id="ContinueLearnUniversity" placeholder="台南應用科技大學" defaultValue={ContinueLearnUniversity} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-5">
                                    <div className="form-group">
                                        <label>學校地址</label>
                                        <input type="text" className="form-control text-primary" name="ContinueLearnLocation" id="ContinueLearnLocation" placeholder="台南市永康..." defaultValue={ContinueLearnLocation} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>進修學位</label>
                                        <input type="text" className="form-control text-primary" name="ContinueLearnDegree" id="ContinueLearnDegree" placeholder="博士/碩士..." defaultValue={ContinueLearnDegree} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-lg-3">
                                    <div className="form-group">
                                        <label>部別</label>
                                        <input type="text" className="form-control text-primary" name="ContinueLearnDivision" id="ContinueLearnDivision" placeholder="日間部/進修部..." defaultValue={ContinueLearnDivision} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>進修學系</label>
                                        <input type="text" className="form-control text-primary" name="ContinueLearnDepartmentName" id="ContinueLearnDepartmentName" placeholder="商品設計系/音樂系..." defaultValue={ContinueLearnDepartmentName} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                        </TabPane>) : ''}
                        {NowStatusPrimarySecondary === '升學升學' ? (<TabPane tab={<span><i className="fas fa-school"></i>{' '}升學進修</span>} key="4" >
                            <div className="form-row">
                                <div className="col-lg-4">
                                    <div className="form-group">
                                        <label>學校名稱</label>
                                        <input type="text" className="form-control text-primary" name="ContinueLearnUniversity" id="ContinueLearnUniversity" placeholder="台南應用科技大學" defaultValue={ContinueLearnUniversity} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg-5">
                                    <div className="form-group">
                                        <label>學校地址</label>
                                        <input type="text" className="form-control text-primary" name="ContinueLearnLocation" id="ContinueLearnLocation" placeholder="台南市永康..." defaultValue={ContinueLearnLocation} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>進修學位</label>
                                        <input type="text" className="form-control text-primary" name="ContinueLearnDegree" id="ContinueLearnDegree" placeholder="博士/碩士..." defaultValue={ContinueLearnDegree} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-lg-3">
                                    <div className="form-group">
                                        <label>部別</label>
                                        <input type="text" className="form-control text-primary" name="ContinueLearnDivision" id="ContinueLearnDivision" placeholder="日間部/進修部..." defaultValue={ContinueLearnDivision} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>進修學系</label>
                                        <input type="text" className="form-control text-primary" name="ContinueLearnDepartmentName" id="ContinueLearnDepartmentName" placeholder="商品設計系/音樂系..." defaultValue={ContinueLearnDepartmentName} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                        </TabPane>) : ''}
                        <TabPane tab={<span><i className="fas fa-graduation-cap"></i>{' '}最高學歷</span>} key="3" >
                            <div className="form-row">
                                <div className="col-lg-8">
                                    <div className="form-group">
                                        <label>學校名稱</label>
                                        <input type="text" className="form-control text-primary" name="LastFinalUniversity" id="LastFinalUniversity" placeholder="台南應用科技大學" defaultValue={LastFinalUniversity} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>畢業學歷</label>
                                        <input type="text" className="form-control text-primary" name="LastFinalDegree" id="LastFinalDegree" placeholder="碩士/學士..." defaultValue={LastFinalDegree} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                            <div className="form-row">
                                <div className="col-lg-7">
                                    <div className="form-group">
                                        <label>學系名稱</label>
                                        <input type="text" className="form-control text-primary" name="LastFinalDepartmentName" id="LastFinalDepartmentName" placeholder="商品設計系/音樂系..." defaultValue={LastFinalDepartmentName} onChange={this.handleChange} />
                                    </div>
                                </div>
                                <div className="col-lg">
                                    <div className="form-group">
                                        <label>班/組</label>
                                        <input type="text" className="form-control text-primary" name="LastFinalMajor" id="LastFinalMajor" placeholder="碩士班/鋼琴組/在職專班..." defaultValue={LastFinalMajor} onChange={this.handleChange} />
                                    </div>
                                </div>
                            </div>
                        </TabPane>
                    </Tabs >
                    <div className="form-row">
                        <div className="col-lg">
                            <div className="form-group">
                                <label>電訪調查說明</label>
                                <input type="text" className="form-control text-primary" id="TelephoneSurveyDescription" placeholder="補充說明" defaultValue={TelephoneSurveyDescription} onChange={this.handleChange} />
                            </div>
                        </div>
                    </div>
                    <div className="form-row">
                        <input type="submit" value="修訂" className="btn btn-warning btn-block btn-sm" />
                    </div>
                </form>
            </Card>
        )
    }
}

export default connect(
    state => ({ user: state.user }),
    {}
)(CounselorEditAlumniModal)